/**
 * Drawer do menu principal no mobile (header).
 */
export function initMobileNav(): void {
    const openBtn = document.querySelector<HTMLButtonElement>('[data-mobile-nav-open]');
    const overlay = document.getElementById('msj-mobile-nav-overlay');

    if (!openBtn || !overlay) {
        return;
    }

    const closeBtn = overlay.querySelector<HTMLButtonElement>('[data-mobile-nav-close]');
    const backdrop = overlay.querySelector<HTMLElement>('[data-mobile-nav-backdrop]');
    const panel = overlay.querySelector<HTMLElement>('[data-mobile-nav-panel]');

    const setOpen = (open: boolean): void => {
        openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
        overlay.classList.toggle('is-open', open);
        document.body.classList.toggle('overflow-hidden', open);

        if (panel) {
            if (open) {
                panel.removeAttribute('inert');
            } else {
                panel.setAttribute('inert', '');
            }
        }

        if (open) {
            closeBtn?.focus({ preventScroll: true });
        } else {
            openBtn.focus({ preventScroll: true });
        }
    };

    openBtn.addEventListener('click', () => {
        setOpen(true);
    });

    closeBtn?.addEventListener('click', () => {
        setOpen(false);
    });

    backdrop?.addEventListener('click', () => {
        setOpen(false);
    });

    overlay.querySelectorAll<HTMLAnchorElement>('a[href]').forEach((link) => {
        link.addEventListener('click', () => {
            setOpen(false);
        });
    });

    document.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key !== 'Escape' || !overlay.classList.contains('is-open')) {
            return;
        }
        event.preventDefault();
        setOpen(false);
    });
}
